export default "__VITE_ASSET__B$0T$vpN__"